import axios from "axios";

export function destroy(id)
{
    return axios.delete(route('api.manage.applications.destroy', { applicationId: id }));
}

export function endpoint(endpoint)
{
    return route(endpoint) + '?include=stage.job,subscriptions,interim,applicationFavorites';
}

export function download(filters, selection, fields)
{
    return axios.post(
        route('api.manage.companies.applications.download'),
        { data: { selection }, fields },
        { params: {
            ...filters,
            limit: 9999,
        }}
        ).then((response) => response.data);
}

export function anonymise(id)
{
    return axios.post(route('api.manage.applications.anonymise', { applicationId: id }));
}

export function massAnonymise(filters, selection, bulkApplicationId)
{
    return axios.post(
        route('api.manage.companies.applications.anonymise'),
        { data: { selection, bulkApplicationId }},
        { params: {
            ...filters,
            limit: 9999,
        }}
    ).then(response => response.data);
}

export function massReject(filters, selection, reject, bulkApplicationId)
{
    return axios.post(
        route('api.manage.companies.applications.reject'),
        { data: { selection, bulkApplicationId, attributes: reject } },
        { params: {
            ...filters,
            limit: 9999,
        }}
    ).then(response => response.data);
}

export function massSubscribe(filters, selection, bulkApplicationId)
{
    return axios.post(
        route('api.manage.companies.applications.subscribe'),
        { data: { selection, bulkApplicationId } },
        { params: {
            ...filters,
            limit: 9999,
        }}
    ).then(response => response.data);
}

export function massUnsubscribe(filters, selection, bulkApplicationId)
{
    return axios.post(
        route('api.manage.companies.applications.unsubscribe'),
        {data: {selection, bulkApplicationId}},
        {
            params: {
                ...filters,
                limit: 9999,
            }
        }
    ).then(response => response.data);
}

export function massUpdateSource(filters, selection, bulkApplicationId, source)
{
    return axios.post(
        route('api.manage.companies.applications.updateSource'),
        { data: { selection, bulkApplicationId, attributes: source }},
        { params: {
            ...filters
        }}
    ).then(response => response.data);
}

let previousRequest = null;

export function sources(excludeEmpty = false, noEmptyLabel = false) {
    return axios
        .get(route('api.manage.companies.applications.sources'),
            {
                params: {
                    exclude_empty_sources: excludeEmpty,
                    no_empty_label: noEmptyLabel,
                }
            })
        .then((response) => {
            return response.data;
        });
}

export function index({
                          sort,
                          extraParameters,
                          page,
                          all = 0,
                          offset,
                          limit,
                          selectedApplications = null,
                      }) {
    if (typeof extraParameters == 'undefined') {
        extraParameters = {};
    }

    // set cancel token
    let cancelToken = axios.CancelToken.source();

    // cancel previous request ?
    if (previousRequest !== null) {
        previousRequest.cancel();
    }

    // reset previous request
    previousRequest = cancelToken;

    return axios
        .get(endpoint('api.manage.companies.applications'), {
            cancelToken: cancelToken.token,
            params: {
                ...extraParameters,
                sort,
                page,
                fetch: (all ? 'all' : ''),
                offset,
                limit,
                selectedApplications,
            }
        })
        .then((response) => {
            previousRequest = null;

            return response.data;
        });
}

export function getForJob(jobId)
{
    return axios.get(route('api.manage.companies.applications') + '?filter[job_id]=' + jobId, {
        params: { limit: 999 }
    })
        .then(response => response.data);
}

export function getForStage(stageId, sort, includeRejected = true, page, perPage)
{
    let params = {
        sort,
        page,
        per_page: perPage ?? 50,
    };

    return axios.get(route('api.manage.companies.applications') +
        '?filter[stage_id]=' + stageId + '&filter[rejected]=' + (includeRejected ? 'all' : '0'), {
        params
    }).then(response => response.data);
}

export function find(id)
{
    const includes = [
        'tags',
        'stage',
        'stage.job',
        'interim',
        'subscriptions',
        'subscriptions.user',
        'originalStage.job',
        'relatedApplications.stage.job',
        'applicationFields',
    ];

    return axios.get(route('api.manage.applications.show', {applicationId: id}) + `?include=${includes.join(',')}`)
        .then(response => {
            return response.data;
        });
}

export function update(applicationId, data, includeJob = false)
{
    return axios.patch(route('api.manage.applications.update', {applicationId}) + '?include=timelineEvents,tags' + (includeJob ? ',stage' : ''), data)
        .then(response => response.data);
}

export function massUpdate(filters, data)
{
    return axios.patch(
        route('api.manage.companies.applications.update'),
        data,
        { params: {
            ...filters,
            include: 'stage.job',
            limit: 9999,
        }}
    ).then(response => response.data);
}

export function addToOfficient(applicationId, data)
{
    return axios.post(route('api.manage.applications.addToOfficient', { applicationId }), data)
        .then(response => response.data);
}

export function store(data)
{
    return axios.post(endpoint('api.manage.companies.applications'), data)
        .then(response => response.data);
}

export function offices()
{
    return axios.get(route('api.manage.companies.applications.offices'))
        .then(response => response.data);
}

export function requestAssessment(applicationId) {
    return axios.post(route('api.manage.applications.request-assessment', {applicationId}))
        .then(response => response.data);
}

export function overview(filters) {
    return axios
        .get(endpoint('api.manage.companies.applications.overview'), {
            params: {
                ...filters
            }
        })
        .then((response) => {
            previousRequest = null;

            return response.data;
        });
}

export function rejectReasons() {
    return axios.get(route('api.manage.companies.applications.reject-reasons'))
        .then(response => response.data);
}
